import TRow from './row.vue'
import TCol from './col.vue'

TRow.install = Vue => {
  Vue.component(TRow.name, TRow)
}

TCol.install = Vue => {
  Vue.component(TCol.name, TCol)
}

export {
  TRow,
  TCol
}



// WEBPACK FOOTER //
// ./src/module/grid/index.js